import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PlaceBookingPaid = ({ location, match, history }) => {
    const { id: placeId } = match.params;
    const { bookingRequest } = location.state;
    // Only allow user to access this page through redirect from the booking
    useEffect(() => {
        if (bookingRequest === undefined) {
            history.push(`/place/${placeId}`);
        }
    }, []);

    return (
        <div id="PlaceBookingPaid" className="container text-center">
            <h1>Thanks for your booking!</h1>
            <p>
                Your Home Stay booking fee payment has been processed and your
                booking is now confirmed. Thank you for booking your home stay
                with Freebird Club!
            </p>
            <br />
            <p>What happens next:</p>
            <p>
                The host has been informed of your booking and will reach out to
                you separately to confirm next steps. Your host will inform you
                of the location of the property, any relevant directions and
                arrival instructions, and when the remainder of the balance for
                your stay should be paid, either on arrival or in advance. They
                will also confirm how the payment should be made, for instance
                by cash, bank transfer, PayPal or another payment method. We do
                not recommend the use of Money gram or Western Union. Hosts
                endeavor to respond as quickly as possible but please note that
                responses can take up to 24 hours.
            </p>
            <br />
            <p>Cancellation:</p>
            <p>
                You can cancel your booking prior to arrival but please note, as
                per our terms and conditions, the online booking fee that you
                paid as part of your booking is non-refundable.
            </p>
            <br />
            <p>
                Please view our FAQs page (
                <a href="https://freebirdclub.com/faq">
                    https://freebirdclub.com/faq
                </a>
                ) for more info.
            </p>
            <p>
                You can view the status of your booking in the Requests section
                of your member dashboard by clicking the button below
            </p>
            <div className="w-100 d-flex justify-content-center">
                <Link
                    className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white text-decoration-none"
                    to={{ pathname: `/dashboard/requests/live` }}
                    dangerouslySetInnerHTML={{
                        __html: `Click here to view booking`,
                    }}
                />
            </div>
        </div>
    );
};

export default PlaceBookingPaid;
